<template>
  <div class="name-status-container">
    <div class="header-search-container" ref="header">
      <van-nav-bar title="名单状态" left-text="返回" left-arrow @click-left="onBack" />
      <van-search v-model="searchValue" placeholder="姓名/手机/身份证/城市/Id" background="#eee" @search="onSearchName" />
      <van-dropdown-menu>
        <van-dropdown-item v-model="nameStatus" :options="nameStatuses" @change="onSearchName" />
        <van-dropdown-item v-model="l1User" :options="l1Users" @change="onSearchName" />
      </van-dropdown-menu>
    </div>
    <div v-if="canView" class="name-statuses">
      <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
        <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onInitData">
          <van-swipe-cell class="name-status-item" v-for="(item, index) in list" :key="index">
            <div class="avatar" :style="{ background: getColor(item) }">
              <img v-if="item.customerInfo && item.customerInfo.avatar" :src="item.customerInfo.avatar">
              <span v-else>{{ item.name[0] || '未' }}</span>
            </div>
            <div class="content">
              <div class="row first-row">
                <span class="name">
                  <span>{{ (item.name || '未知') }}</span>
                  <span class="supplier" v-if="item.smsNamesSupplier">@{{ item.smsNamesSupplier }}</span>
                  <span class="phase">{{ StatusMap[item.phase] }}</span>
                </span>
              </div>
              <div class="row second-row">
                <span class="creater">
                  <span style="margin-right: 8px;">创建人：<span class="createBy">{{ item.createBy }}</span></span>
                  <span>处理人：<span class="createBy">{{ item.currentUserName || '无' }}</span></span>
                </span>
              </div>
              <div class="row third-row">
                <span class="time" style="margin-right: 8px;">
                  创建时间：{{ item.createTime }}
                </span>
                <span class="time">
                  所属城市：<span class="diff-time" @click="onShowCityPicker(item)">{{ getCityName(item) }}</span>
                </span>
              </div>
            </div>
            <template #right>
              <van-button v-if="['new', 'wait-visit'].includes(item.phase)" square text="开始" type="danger"
                @click="onCloseName(item)" class="action-button" />
            </template>
          </van-swipe-cell>
        </van-list>
      </van-pull-refresh>
    </div>
    <van-empty v-else image="network" description="抱歉，您访问的页面不存在" />
    <van-popup v-model="showCityPicker" position="bottom">
      <van-picker show-toolbar :columns="dataColumns" @confirm="onConfirmCity" @cancel="showCityPicker = false" />
    </van-popup>
  </div>
</template>
<script>
import DayJs from 'dayjs'
import { hasOneOf, formatDate } from '@/util'
import { StatusMap } from '@/constants'
import { areaList } from '@/constants/area'
import { fetchRoleCodeList, getUserList } from '@/services/UserService'
import { getNameList, getNameDetailById, saveNameDetail, commitStatus } from '@/services/CustomerService'

export default {
  data() {
    return {
      StatusMap,
      openId: localStorage.getItem('openId'),
      roleCodeList: [],
      loading: false,
      searchValue: '',
      l1Users: [],
      pageNum: 1,
      pageSize: 0,
      total: 0,
      list: [],
      currentName: {},
      currentNameDetail: {},
      finished: false,
      refreshing: false,
      showCityPicker: false,
      dataColumns: ['上海', '南通', '苏州', '南京'],
      nameStatus: '',
      l1User: ''
    }
  },
  computed: {
    canView() {
      return this.roleCodeList && this.roleCodeList.length &&
        hasOneOf(this.roleCodeList, ['T', 'M', 'L1'])
    },
    nameStatuses() {
      const statuses = Object.keys(StatusMap).map(key => ({
        text: StatusMap[key],
        value: key
      }))
      statuses.unshift({
        text: '全部状态',
        value: ''
      })
      return statuses
    }
  },
  async mounted() {
    this.pageSize = 20

    this.$toast.loading({
      duration: 0,
      message: '数据加载中...',
      forbidClick: true
    })
    await this.onInitRoleCodeList()
    await this.onInitUsers()
    this.$toast.clear()
  },
  beforeUnmount() {
    clearInterval(this.timer)
  },
  methods: {
    formatDate,
    async onInitRoleCodeList() {
      const openId = localStorage.getItem('openId')
      const response = await fetchRoleCodeList({ openId })
      this.roleCodeList = response.data || []
    },
    async onInitUsers() {
      const response = await getUserList({
        openId: this.openId,
        pageNum: 1,
        pageSize: 2000
      })
      const l1Users = ((response.data || {}).records || [])
        .filter(user => user.status === 0 && hasOneOf(user.roleCodeList, ['L1']))
        .map(user => ({
          text: user.name,
          value: user.userId
        }))
      l1Users.unshift({
        text: '全部主管',
        value: ''
      })
      this.l1Users = l1Users
    },
    async onInitData() {
      if (this.refreshing) {
        this.list = []
        this.pageNum = 1
        this.refreshing = false
      }
      const response = await getNameList({
        openId: this.openId,
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        keyword: this.searchValue || undefined,
        status: this.nameStatus || undefined,
        mUserIdList: this.l1User ? [this.l1User] : undefined
      })
      const data = response.data
      data.records.forEach(name => {
        if (name.lastDialTime) {
          const diffHours = DayJs(new Date()).diff(DayJs(name.lastDialTime), 'hours')
          if (diffHours < 24) {
            name.diffTime = diffHours || 1
            name.diffTimeUnit = 'H'
          } else {
            name.diffTime = Math.ceil(diffHours / 24)
            name.diffTimeUnit = 'D'
          }
        }
        if (name.nextTouchTime) {
          name.nextTouchTimeIsValid = DayJs(name.nextTouchTime).isAfter(DayJs())
        } else {
          name.nextTouchTime = ''
          name.nextTouchTimeIsValid = false
        }
      })
      this.list = [...this.list, ...data.records]
      this.total = data.total
      this.pageNum = data.current + 1
      this.pageSize = data.size

      this.loading = false
      if (this.list.length >= this.total) {
        this.finished = true
      }
    },
    onBack() {
      this.$router.back()
    },
    async onSearchName() {
      this.pageNum = 1
      this.list = []
      this.$toast.loading({
        duration: 0,
        message: '数据加载中...',
        forbidClick: true
      })
      await this.onInitData()
      this.$toast.clear()
    },
    onRefresh() {
      this.finished = false
      this.loading = true
      this.onInitData()
    },
    async onShowCityPicker(item) {
      this.$toast.loading({
        duration: 0,
        message: '数据加载中...',
        forbidClick: true
      })
      const response = await getNameDetailById({
        openId: this.openId,
        id: item.id
      })
      this.currentNameDetail = response.data
      this.$toast.clear()
      this.showCityPicker = true
      this.currentName = item
    },
    async onConfirmCity(value) {
      this.showCityPicker = false
      this.$set(this.currentName, 'cityName', value)
      this.$toast.loading({
        duration: 0,
        message: '数据加载中...',
        forbidClick: true
      })
      const cityMap = {
        '上海': '310000',
        '南通': '320600',
        '苏州': '320500',
        '南京': '320100'
      }
      await saveNameDetail({
        openId: this.openId,
        id: this.currentName.id,
        workInfo: {
          ...this.currentNameDetail.workInfo,
          workCity: cityMap[value]
        }
      })
      this.$toast.clear()
    },
    async onCloseName(item) {
      this.$toast.loading({
        duration: 0,
        message: '数据加载中...',
        forbidClick: true
      })
      const response = await commitStatus({
        openId: this.openId,
        id: item.id,
        fromStatus: item.phase,
        toStatus: 'closed'
      })
      if (response.code === 1000) {
        item.status = 'closed'
      }
      this.$toast.clear()
    },
    getColor(item) {
      const id = item.refLoanId || item.id
      const colors = ['#19be6b', '#ff9900', '#2d8cf0', '#808695']
      return colors[id % colors.length]
    },
    getCityName(item) {
      if (item.cityName) {
        if (Array.isArray(item.cityName)) {
          return areaList[item.cityName[1]] || item.cityName
        } else {
          return areaList[item.cityName] || item.cityName
        }
      }
      if (item.enterpriseInfo && item.enterpriseInfo.enterpriseCity) {
        return areaList[item.enterpriseInfo.enterpriseCity]
      }
      return '暂无'
    }
  }
}
</script>
<style lang="less">
.name-status-container {
  background: #fff;

  .header-search-container {
    position: fixed;
    left: 0;
    right: 0;
    z-index: 2;

    .van-dropdown-menu__item {
      background-color: rgb(238, 238, 238);
    }
  }

  .name-statuses {
    padding: 155px 5px 5px 5px;

    .name-status-item {
      background: #f6f6f6;
      padding: 5px 0 5px 5px;
      border-radius: 5px;
      margin-bottom: 5px;
      color: rgba(0, 0, 0, 0.45);

      .avatar {
        width: 40px;
        height: 40px;
        font-size: 18px;
        line-height: 40px;
        text-align: center;
        border-radius: 50%;
        color: #fff;
        overflow: hidden;
        margin-right: 10px;
        margin-top: 6px;

        img {
          width: 100%;
          height: 100%;
        }
      }

      .content {
        padding-bottom: 10px;

        .row {
          &.first-row {
            height: 30px;
            line-height: 30px;
          }

          &.second-row {
            height: 24px;
            line-height: 24px;
          }

          &.third-row {
            height: 24px;
            line-height: 24px;
            margin-top: 4px;
          }

          .name {
            color: #2d8cf0;
            font-size: 18px;

            .supplier {
              color: rgb(237, 64, 20);
              font-size: 15px;
            }

            .phase {
              margin-left: 6px;
              color: rgba(0, 0, 0, 0.85);
              font-size: 15px;
              font-weight: 600;
            }
          }

          .creater {
            font-size: 13px;

            .createBy {
              color: rgb(45, 140, 240);
            }
          }

          .time {
            font-size: 13px;

            .diff-time {
              color: #2d8cf0;
            }
          }

          .touch-time {
            font-size: 13px;
            color: #f90;
          }

          .contact {
            font-size: 13px;
          }
        }
      }

      .van-swipe-cell__wrapper {
        display: flex;
        margin-right: -1px;

        .action-button {
          height: 100%;
        }
      }
    }
  }

  .van-empty {
    height: 100vh;
  }

  .no-auth {
    height: 100vh;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-top: 100px;

    img {
      width: 80%;
    }

    p {
      margin-top: 16px;
      color: #808695;
      font-size: 20px;
      line-height: 28px;
    }
  }
}
</style>
